import { render, staticRenderFns } from "./WechatFloat.vue?vue&type=template&id=0a15bf23&scoped=true"
import script from "./WechatFloat.vue?vue&type=script&lang=js"
export * from "./WechatFloat.vue?vue&type=script&lang=js"
import style0 from "./WechatFloat.vue?vue&type=style&index=0&id=0a15bf23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a15bf23",
  null
  
)

export default component.exports